import React, { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable, Modal } from '~/components';
import {
    deleteLimiteAbastecimento,
    findLimiteAbastecimento,
    recordFiltering,
} from '~/store/modules/limiteAbastecimento/actions';
import { parseISO, format } from 'date-fns';
import { Edit } from '@material-ui/icons';

import Form from './form';

export default function LimiteAbastecimento() {

    const modalRef = useRef(null)


    const data = useSelector((state) => state.limiteAbastecimento);

    const header = useMemo(
        () => [
            {
                id: 'clab_codigo',
                label: 'Codigo',
            },
            {
                id: 'clab_datahora_atu',
                label: 'Última atualização',
                formatted: (value) =>
                    value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : value,
            },
            {
                id: 'clab_status_str',
                label: 'Status',
                align: 'center',
            },
            {
                id: 'clab_tipo_str',
                label: 'Tipo',
                align: 'center',
            },
            {
                id: 'clab_cota',
                label: 'Cota',
                align: 'center',
            },
        ],
        []
    );

    const buttons = useMemo(() => [
        {
            title: 'Editar',
            icon: <Edit />,
            action: (value) => modalRef.current.handleOpenModal({ data: value })
        }
    ])

    return (
        <>
            <UnidataTable
                pdf
                excel
                reportOrder="clab_codigo ASC"
                fixed
                update={false}
                delete={false}
                create={false}
                read={recordFiltering}
                find={findLimiteAbastecimento}
                remove={deleteLimiteAbastecimento}
                redux={data}
                header={header}
                actions={buttons}
                detach="clab_status_str"
                keys={['clab_codigo']}
                form={Form}
                view="VW_TB_CONFIG_LIMITE_ABASTECIMENTO"
                reportTitle="Limite Abastecimento"
            />

            <Modal
                form
                disableBackDropClick
                disableEscapeKeyDown
                ref={modalRef}
                maxWidth="sm"
                title="Editar Limite Abastecimento"
                component={Form}

            />
        </>

    );
}
